import { Pipe, PipeTransform } from "@angular/core";
import * as moment_ from "moment";
import { formatBytesString } from '../functions/string.helpers';

@Pipe({
  name: "bytesFormat"
})
export class BytesFormatPipe implements PipeTransform {
  transform(value: any): any {
    return formatBytesString(value);
  }
}
